module.exports = __webpack_public_path__ + "static/meandkoda2bw-1e87f88cce11c27167608cf09a9d7f09.png";